export default __webpack_public_path__ + "static/media/transparent-white-ph-spinner.eed42708.gif";